export default __webpack_public_path__ + "static/customer-service-a3e9000762f640a1218e5a9f49540995.png";